import type { Heat } from '@sprinters/shared';
import { formatTime } from '../../format';
import { h } from '../dom';

/** Tableau des résultats d'une série terminée. */
export function renderResultsTable(
  heat: Heat,
  myEntrantId: string | null,
  isFinal: boolean,
): HTMLElement {
  const results = heat.results;
  if (!results) return h('p', { class: 'muted' }, 'Résultats indisponibles.');

  return h(
    'table',
    { class: 'results' },
    h(
      'thead',
      null,
      h(
        'tr',
        null,
        h('th', null, '#'),
        h('th', null, 'Coureur'),
        h('th', null, 'Temps'),
        h('th', null, 'Chutes'),
        h('th', null, ''),
      ),
    ),
    h(
      'tbody',
      null,
      ...results.map((result) => {
        const entrant = heat.lanes.find((lane) => lane.id === result.entrantId);
        const statusLabel = result.qualified
          ? isFinal
            ? 'Champion'
            : 'Qualifié'
          : isFinal
            ? ''
            : 'Éliminé';
        return h(
          'tr',
          {
            class: `${result.entrantId === myEntrantId ? 'is-me' : ''}${result.qualified ? ' is-qualified' : ''}`,
          },
          h('td', null, result.rank),
          h('td', { class: entrant?.kind === 'bot' ? 'is-bot' : '' }, entrant?.name ?? '?'),
          h('td', null, formatTime(result.timeMs)),
          h('td', null, result.falls),
          h(
            'td',
            null,
            statusLabel &&
              h(
                'span',
                { class: `chip ${result.qualified ? 'chip-done' : 'chip-out'}` },
                statusLabel,
              ),
          ),
        );
      }),
    ),
  );
}
